import { ISetOwnerParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class SetPublishedConnectionsOwnerRequest extends Request<ISetOwnerParams, IResult> {
  constructor(ids: string[], ownerId: string) {
    super('setPublishedConnectionsOwner', {
      ids: ids,
      ownerId: ownerId
    });
  }
}
